var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66659 5.66665C1.66659 3.46098 3.46092 1.66665 5.66659 1.66665C7.87225 1.66665 9.66658 3.46098 9.66658 5.66665C9.66658 7.87231 7.87225 9.66665 5.66659 9.66665C3.46092 9.66665 1.66659 7.87231 1.66659 5.66665ZM13.4713 12.5286L9.87592 8.93331C10.5779 8.03031 10.9999 6.89898 10.9999 5.66665C10.9999 2.72131 8.61192 0.333313 5.66659 0.333313C2.72125 0.333313 0.333252 2.72131 0.333252 5.66665C0.333252 8.61198 2.72125 11 5.66659 11C6.89892 11 8.03025 10.578 8.93325 9.87598L12.5286 13.4713C12.6589 13.6016 12.8293 13.6666 12.9999 13.6666C13.1706 13.6666 13.3409 13.6016 13.4713 13.4713C13.7316 13.211 13.7316 12.789 13.4713 12.5286Z",
    fill: "#4F7DBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.285e6da7320348ef5885a2d536da1d00.svg";
export { ForwardRef as ReactComponent };